<template>
    <div class="tabs">
        <div class="flex">
            <div
                v-for="(tab, index) in tabs"
                :key="index"
                @click="selectTab(index)"                
                class="font-bold mr-10 hover:text-blas-900 "
                :class="{'underline': index === selectedIndex, 'text-blas-900' : index === selectedIndex, 'text-blas-600' : index !== selectedIndex}"
            >
                {{ tab.props.title }}
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import {defineComponent, reactive, provide, onMounted, onBeforeMount, toRefs, VNode} from "vue";


export default defineComponent({
    name: "Tabs",
    setup(_, {slots}) {
        const state = reactive({
            selectedIndex: 0,
            tabs: [] ,
            count: 0
        });

        provide("TabsProvider", state);

        const selectTab = (i) => {
            state.selectedIndex = i;
        };

        onBeforeMount(() => {
            if (slots.default) {
                state.tabs = slots.default().filter((child) => child.type.name === "Tab");
            }
        });

        onMounted(() => {
            selectTab(0);
        });

        return {...toRefs(state), selectTab};
    }
});
</script>